import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import OrderModel from "../../model/OrderModel";

export class PageOrderDetailStore {
    private rootStore: RootStore | undefined;

    arModalData = [];
    orderId = 0

    public error: string = '';


    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }


    @action init(id:number) {
        this.onOpenModal(id);
    }


    @action
    setError = (error: any) => {
        console.log(error)
    }

    repeatOrder = (result: any) => {
        this.rootStore?.mainStore.setRedirectUrl('/basket');
    }

    @action
    onOpenModal = (id: number) => {

        this.rootStore?.pageOrderStore.removeWebPayLink()
        this.arModalData = [];
        this.orderId = id
        OrderModel.getProductInfoOrder(id, this.setModalData, this.setError)
    }

    @action
    setModalData = (result: any) => {
        this.arModalData = result.data;

        if (!result.data[0].isPaid && result.data[0].paymentType === 7){
            this.rootStore?.pageOrderStore.takeWebPayLink(this.orderId)
        }

    }

}
